import orderInstance from '../instance'

const putAutoConfirmation = data => {
   return  orderInstance.put('/auto-confirmation', data)
}

export default putAutoConfirmation

